// extracted by mini-css-extract-plugin
module.exports = {"dialog":"Loading_dialog__39OoN","mainDiv":"Loading_mainDiv__HHC8j","textSpan":"Loading_textSpan__1HWBp"};